import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-d6eeea7c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["hide"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0,
  alt: "Website Logo"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "title",
  id: "title"
}, "FSA Evaluator", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: ".\\wikia.html" }, "Wiki")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", { href: "https://github.com/Mamiglia/meravigliosi-automi" }, "Source Code")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  "aria-label": "open menu"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["hide"]

import { ref} from 'vue'


export default /*#__PURE__*/_defineComponent({
  emits: ["startTutorial"],
  setup(__props) {



const hasFocus = ref(true)


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: "sidemenu",
      hide: !hasFocus.value
    }, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (hasFocus.value=false)),
        "aria-label": "start"
      }, "start >")
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: "menu-btn",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (hasFocus.value=true))
    }, _hoisted_7),
    _createElementVNode("span", {
      class: "outside",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (hasFocus.value=false)),
      hide: !hasFocus.value
    }, null, 8, _hoisted_8)
  ], 64))
}
}

})